const menuAuthAndArea = [
  {
    menuName: '权限管理',
    id: '201',
    icon: 'setting',
    children: [
      {
        menuName: '管理员维护',
        path: '/manager',
      },
      {
        menuName: '用户角色',
        path: '/authGroup',
      },
      {
        menuName: '权限列表',
        path: '/authRule',
      },
    ],
  },
  {
    menuName: '数据权限',
    id: '202',
    icon: 'setting',
    children: [
      {
        menuName: '大区列表',
        path: '/area',
      },
    ],
  },
];

export const menuData = [
  {
    menuName: '客户管理',
    id: '1',
    icon: 'setting',
    children: [
      {
        menuName: '药企管理',
        path: '/business',
      },
      {
        menuName: '服务商管理',
        path: '/service',
      },
      // {
      //   menuName: '协议管理',
      //   path: '/Agreement',
      // },
	  {
	    menuName: '企业库管理',
	    path: '/enterpriseBrand',
	  },
    ],
  },

  {
    menuName: '终端人员管理',
    id: '2',
    icon: 'setting',
    children: [
      // drop by zim, 已经被权限管理下“管理员维护”替换
      // {
      //   menuName: '账号管理',
      //   path: '/account',
      // },
      {
        path: '/promoter',
        menuName: '推广员管理',
      },
      {
        path: '/doctor',
        menuName: '医生管理',
      },
    ],

  },
  {
    menuName: '活动管理',
    id: '3',
    icon: 'setting',
    children: [
      {
        menuName: '类型管理',
        path: '/type',
        icon: 'switcher',
      },
      {
        menuName: '服务活动管理',
        path: '/activity',
        icon: 'book',
      },
      {
        menuName: '报告表单配置',
        path: '/activityConfig',
        icon: 'hdd',
      },
    ],
  },
  {
    menuName: '资源管理',
    id: '4',
    icon: 'setting',
    children: [
      {
        menuName: '调研题库',
        path: '/questionReport',
      },
      {
        menuName: '调研模板',
        path: '/templateReport',
      },
      {
        path: '/article',
        menuName: '文章管理',
        icon: 'alert',
      },
      {
        path: '/video',
        menuName: '视频管理',
        icon: 'alert',
      },


      {
        path: '/label',
        menuName: '标签管理',
      },
    ],
  },
  {
    menuName: '系统管理',
    id: '5',
    icon: 'setting',
    children: [
      {
        menuName: '消息管理',
        path: '/message',
        icon: 'alert',
      },
      {
        menuName: '科室管理',
        path: '/section',
        icon: 'alert',
      },
      {
        menuName: '职称管理',
        path: '/rank',
        icon: 'alert',
      },
      {
        menuName: '栏目管理',
        path: '/column',
        icon: 'alert',
      },
      {
        menuName: '广告管理',
        path: '/adver',
      },
    ],
  },
  {
    menuName: '财务管理',
    id: '6',
    icon: 'setting',
    children: [
      {
        path: '/score',
        menuName: '积分管理',
      },
      {
        path: '/cash',
        menuName: '提现列表',
      },
    ],
  },
  {
    menuName: '线上学术推广',
    id: '7',
    icon: 'setting',
    children: [
      {
        path: '/promotefeed',
        menuName: '推广反馈',
      },
      {
        path: '/task',
        menuName: '任务列表',
      },
      {
        path: '/research',
        menuName: '调研反馈',
      },
      {
        path: '/question',
        menuName: '提问评价',
      },
    ],
  },
  {
    menuName: '网站设置',
    id: '8',
    icon: 'setting',
    children: [
      {
        path: '/web',
        menuName: '网站信息',
      },
    ],
  },
  ...menuAuthAndArea,
];
